const NotificationDialog = ({ notificationMessage, isError }) => {
  return (
    <p className={isError ? "text-red-500" : "text-green-500"}>
      {notificationMessage}
    </p>
  );
}

export default NotificationDialog;
